exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".frameLandscapeIcon1 {\n  fill:#f9fbfc;\n}\n\n.frameLandscapeIcon2 {\n  fill:#bdc4c9;\n}", ""]);
